<template>
	<div class="dpIB posR">
		<svg :width="2 * (radius + strokeWidth)" :height="2 * (radius + strokeWidth)" style="transform: rotate(-90deg)">
			<circle
				id="circle"
				:cx="radius + strokeWidth"
				:cy="radius + strokeWidth"
				:r="radius"
				fill="none"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				:style="`stroke-dasharray:${perimeter},${perimeter};stroke-dashoffset: ${stroke};`"
				class="cir"
				:class="strokeColor"
			/>
		</svg>
		<div class="posA ofH" :style="`top: ${strokeWidth}px;left: ${strokeWidth}px; width: ${2 * radius}px; height: ${2 * radius}px;`">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "Stroke",
	props: {
		step: {
			type: Number,
			default: 0,
		},
		strokeWidth: {
			type: Number,
			default: 2,
		},
		strokeColor: {
			type: String,
			default: "sMain",
		},
		size: {
			// 3代表3个rem
			type: Number,
			default: 3,
		},
	},
	components: {},
	data() {
		return {};
	},
	methods: {},
	created() {},
	computed: {
		stroke() {
			return this.perimeter - (this.perimeter * this.step) / 100;
		},
		radius() {
			return (this.size * stage.space) / 2 - this.strokeWidth;
		},
		perimeter() {
			return parseInt(Math.PI * 2 * this.radius);
		},
	},
};
</script>

<style lang="scss" scoped>
.cir {
	transition: all 0.2s cubic-bezier(0.6, 0, 0.4, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Stroke.vue